import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useCallback } from 'react';

import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/fields/select.module.scss';

const propTypes = {
    className: PropTypes.string,
    placeholderClassName: PropTypes.string,
    placeholder: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            label: PropTypes.string,
        }),
    ),
    value: PropTypes.string,
    required: PropTypes.bool,
    onChange: PropTypes.func,
};

const defaultProps = {
    className: null,
    placeholderClassName: null,
    placeholder: null,
    items: null,
    value: null,
    required: false,
    onChange: null,
};

const SelectField = ({
    className,
    placeholderClassName,
    placeholder,
    items,
    value,
    required,
    onChange,
}) => {
    const themeClassName = useThemeClassName(styles);
    const currentItem =
        (items || []).find(({ value: itemValue = null }) => itemValue === value) || null;
    const unselected = currentItem === null || value === null;
    const selectedLabel = currentItem !== null ? currentItem.label || null : placeholder;

    const onPrivateChange = useCallback(
        (e) => {
            if (onChange !== null) {
                onChange(e.target.value);
            }
        },
        [onChange],
    );

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                className,
                {
                    [styles.unselected]: unselected,
                },
            ])}
        >
            <div className={classNames([styles.selected, placeholderClassName])}>
                {selectedLabel}
            </div>
            <FontAwesomeIcon className={styles.arrow} icon={faChevronDown} />
            <select
                className={styles.nativeSelect}
                value={value || ''}
                onChange={onPrivateChange}
                required={required}
            >
                <option value="">{placeholder}</option>
                {items.map(
                    ({ value: itemValue = null, label = null, disabled = false }, itemIndex) => (
                        <option key={`item-${itemIndex + 1}`} value={itemValue} disabled={disabled}>
                            {label}
                        </option>
                    ),
                )}
            </select>
        </div>
    );
};

SelectField.propTypes = propTypes;
SelectField.defaultProps = defaultProps;

export default SelectField;
